import { FC } from 'react'

export interface ILastCharactersStrong {
  label: string
  color?: string
  size?: number
  fontWeight?: string
}

export const LastCharactersStrong: FC<ILastCharactersStrong> = ({
  label,
  color,
  size = 4,
  fontWeight = '600',
}) => {
  const last = label.substring(label.length - size)
  const init = label.substring(0, label.length - size)

  return (
    <span>
      {init}
      <span
        style={{
          color: color,
          fontWeight: fontWeight,
        }}
      >
        {last}
      </span>
    </span>
  )
}
